"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInvalidUSCanadaPhoneNumber = void 0;
const INVALID_AREA_CODES = ["123", "000", "111", "222", "333", "444", "555", "666", "777", "888", "999"];
function isInvalidUSCanadaPhoneNumber(phoneNumber) {
    const phoneWithoutExt = phoneNumber.split(/x|X|#/)[0];
    const phoneNumberDigits = phoneWithoutExt.replace(/\D/g, "");
    if (phoneNumberDigits.length < 10 || phoneNumberDigits.length > 11) {
        return true;
    }
    if (phoneNumberDigits.length === 11 && phoneNumberDigits.charAt(0) !== "1") {
        return true;
    }
    const areaCode = phoneNumberDigits.length === 11 ? phoneNumberDigits.substring(1, 4) : phoneNumberDigits.substring(0, 3);
    if (["0", "1"].includes(areaCode.charAt(0)) || INVALID_AREA_CODES.includes(areaCode)) {
        return true;
    }
    return false;
}
exports.isInvalidUSCanadaPhoneNumber = isInvalidUSCanadaPhoneNumber;
//# sourceMappingURL=PhoneNumberUtils.js.map